import { ComponentType } from 'react';
import { Navigate } from 'react-router-dom';

import Home from './pages/Home';
import { Environment } from './pages/Environment';
import { Scene } from './pages/Scene';
import { BenchmarkAndLeaderboard } from './pages/BenchmarkAndLeaderboard/BenchmarkAndLeaderboard';
import { MolmoManip } from './pages/MolmoManip';
import { Test } from './pages/Test';
import { SceneRecorder } from './pages/SceneRecorder';
import { useFeatureFlags } from './contexts/FeatureFlagContext';

export interface AppRoute {
  /* The url path, i.e. in the url `http://localhost/about`, `/about` is the path. */
  path: string;
  /* The name of the route that's displaed in the navigation. */
  label: string;
  /* The component that's rendered when that route is active. */
  Component: ComponentType;
}

/**
 * Root component that conditionally renders Home page or redirects to /environment
 * based on the feature flags
 */
function RootRoute() {
  const { isHomePageEnabled } = useFeatureFlags();

  return isHomePageEnabled ? <Home /> : <Navigate to="/environment" replace />;
}

export const ROUTES: AppRoute[] = [
  {
    path: '/',
    label: 'Home',
    Component: RootRoute,
  },
  {
    path: '/environment',
    label: 'environment',
    Component: Environment,
  },
  {
    path: '/old_scene/:slug',
    label: 'old_scene',
    Component: Scene,
  },
  {
    path: '/leaderboard',
    label: 'leaderboard',
    Component: BenchmarkAndLeaderboard,
  },
  {
    path: '/leaderboard/ms',
    label: 'leaderboard-ms',
    Component: BenchmarkAndLeaderboard,
  },
  {
    path: '/leaderboard/mb',
    label: 'leaderboard-mb',
    Component: BenchmarkAndLeaderboard,
  },
  {
    path: '/molmo-manip',
    label: 'molmo-manip',
    Component: MolmoManip,
  },
  {
    path: '/scene/:slug',
    label: 'scene',
    Component: Test,
  },

  {
    path: '/recorder/:slug',
    label: 'scene_recorder',
    Component: SceneRecorder,
  },
];
